<template>
    <nav class="nav">
        <div class="nav__content">
            <router-link v-bind:to="{ name: 'Home' }">
                <img src="assets/images/logo_white.svg" alt="PlanIt Logo" class="site-logo" />
            </router-link>

            <div class="nav__links" v-if="loggedIn">
                <router-link v-bind:to="{ name: 'Home' }">Home</router-link>
                <router-link v-bind:to="{ name: 'ExploreItineraries' }">Explore itineraries</router-link>
                <router-link v-bind:to="{ name: 'CreateItinerary' }">Plan your trip</router-link>
                <router-link v-bind:to="{ name: 'FAQ' }">FAQs</router-link>
                <router-link v-bind:to="{ name: 'ContactUs' }">Contact Us</router-link>

                <router-link class="nav__user"
                    v-bind:to="{ name: 'MyProfile' }">
                    <img src="assets/images/avatar1.png" class="avatar" alt="Kevin's avatar" />

                    <div class="dropdown-trigger">Hi, Kevin!
                        <i class="arrow-icon"
                            v-on:click.prevent="loggedIn = !loggedIn"></i>
                    </div>
                </router-link>
            </div>

            <div class="nav__buttons" v-else>
                <button v-on:click="openSignUpPopup">Sign Up</button>
                <button v-on:click="openLoginPopup">Log In</button>
            </div>
        </div>

        <SignUpPopup v-if="openedSignUpPopup"></SignUpPopup>
        <LoginPopup v-if="openedLoginPopup"></LoginPopup>
    </nav>
</template>

<script>
    import Eventbus from '../modules/eventbus'

    export default {
        name: 'AppNav',
        components: {
            SignUpPopup: require('./signUpPopup').default,
            LoginPopup: require('./loginPopup').default
        },
        data: function() {
            return {
                loggedIn: false,
                openedSignUpPopup: false,
                openedLoginPopup: false
            }
        },
        methods: {
            openSignUpPopup: function() {
                document.querySelector('body').style.overflow = 'hidden'
                this.openedSignUpPopup = true
            },
            openLoginPopup: function() {
                document.querySelector('body').style.overflow = 'hidden'
                this.openedLoginPopup = true
            },
            closeAllPopups: function() {
                this.openedSignUpPopup = false
                this.openedLoginPopup = false
                document.querySelector('body').style.overflow = 'auto'
            }
        },
        mounted: function() {
            let _this = this
            let body = document.querySelector('body')

            Eventbus.$on('closeSignUpPopup', _this.closeAllPopups)
            Eventbus.$on('closeLoginPopup', _this.closeAllPopups)

            Eventbus.$on('loginUser', function() {
                _this.closeAllPopups()
                _this.loggedIn = true
            })

            window.addEventListener('keydown', function(e) {
                if (e.keyCode == 27 && (_this.openedSignUpPopup
                    || _this.openedLoginPopup)) {
                    _this.closeAllPopups()
                }
            })
        }
    }
</script>

<style scoped lang="scss">
    .nav {
        background-color: $navy;
        position: relative;
        padding: 0 24px;
        z-index: 2;

        @media all and (max-width: $breakpoint) {
            padding: 0 15px;
        }
    }

    [data-page="home"] .nav,
    [data-page="itinerary"] .nav,
    [data-page="create-itinerary"] .nav {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }

    [data-page="home"] .nav,
    [data-page="itinerary"] .nav {
        background-color: rgba(255, 255, 255, 0.1);
    }


    .nav__content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 1265px;
        height: 64px;
        margin: 0 auto;

        @media all and (max-width: $breakpoint) {
            height: 50px;
        }
    }


    .site-logo {

        @media all and (max-width: $breakpoint) {
            width: 50px;
            height: auto;
        }
    }


    button {
        font-weight: $medium;
        color: rgba(255, 255, 255, 0.7);
    }

    button:last-child {
        margin-left: 48px;

        @media all and (max-width: $breakpoint) {
            margin-left: 20px;
        }
    }


    .nav__links {
        display: flex;
        align-items: center;
        font-weight: $medium;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
    }


    .nav__links > :not(:first-child) {
        margin-left: 48px;
    }


    .nav__links a {
        color: inherit;
    }

    .nav__links a:not(.nav__user) {

        @media all and (max-width: 910px) {
            display: none;
        }
    }

    .router-link-exact-active.router-link-active {
        font-weight: $heavy;
        color: $accent;
    }


    .nav__user {
        display: flex;
        align-items: center;
    }


    .dropdown-trigger {
        cursor: pointer;

        @media all and (max-width: 910px) {
            font-size: 0;
        }
    }


    .avatar {
        margin-right: 10px;
        width: 28px;
        height: 28px;
        border: 1px solid rgba(255, 255, 255, 0.7);

        @media all and (max-width: 910px) {
            margin-right: 7px;
        }
    }


    .nav__user {
        font-weight: $medium;
    }


    .arrow-icon {
        margin-left: 10px;
        opacity: 0.7;
        width: 12px;
        height: 12px;

        @media all and (max-width: 910px) {
            margin-left: 0;
        }
    }
</style>
